import styled from 'styled-components';

export const Screen = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  background-color: #edf2f5;

  > div:last-child {
    display: flex;
    flex-direction: row;
  }

  .doc-no {
    display: flex;
    flex-direction: row;
    margin-bottom: 15px;

    .input-field {
      max-width: 300px;
      width: 100%;
    }
  }
`;
